module.exports = __webpack_public_path__ + "img/大数据分析报告.756826ab.png";